import useWindowWidth from './useWindowWidth';
import { useEffect, useRef } from 'react';
function getTopPositioning(el, adjust) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
    bottom = _el$getBoundingClient.bottom,
    top = _el$getBoundingClient.top;
  if (Math.ceil(bottom) === window.innerHeight) {
    return window.innerHeight - top + adjust;
  } else {
    return (Math.abs(bottom) === bottom ? bottom : bottom + window.pageYOffset) + adjust;
  }
}

/**
 * Big note: this doesn't support browsers that don't support position: sticky
 * @param {string} sticksTo selector string of element this will attach to
 * @param {number} adjust vertical adjustment in pixels (for things like borders
 *   causing issues)
 */
export default function useSticky(sticksTo) {
  var adjust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ref = useRef(null);
  var width = useWindowWidth();
  useEffect(function () {
    if (sticksTo) {
      var el = document.querySelector(sticksTo);
      var stickyEl = ref.current;
      if (el && stickyEl) {
        // ideally this would be handled by state, but cleaner to not have to
        // pass those props down and merge with other styles
        stickyEl.style.top = getTopPositioning(el, adjust) + 'px';
      }
    }
  }, [width, adjust, sticksTo, ref]);
  return ref;
}